import React, { createContext, useContext } from 'react';
import { ConfigProvider, Empty } from 'antd';
import moment from 'moment';
import numeral from 'numeral';
import i18n from 'i18next';
import { initReactI18next, useTranslation } from 'react-i18next';
import frFR from 'antd/lib/locale/fr_FR';
import fr_FR from '../locales/fr_FR.json';
import 'moment/locale/fr';
import 'numeral/locales/fr';

moment.locale('fr');
numeral.locale('fr');

numeral.register('format', 'siren', {
  regexps: { format: /(siren)/ },
  format: (value) => {
    const str = Object.values(`${value}`);
    let output = '';
    let count = 0;

    str.forEach((c) => {
      if (count % 3 === 0) output += ' ';
      output += c;
      count += 1;
    });
    return output;
  }
});

const customizeRenderEmpty = () => <Empty />;

i18n.use(initReactI18next).init({
  resources: {
    fr_FR
  },
  lng: 'fr_FR',
  fallbackLng: 'fr_FR',
  interpolation: {
    escapeValue: false
  }
});

const LanguageContext = createContext({});

export const LanguageContextProvider = ({ children }) => {
  const { t } = useTranslation();

  const validateMessages = {
    required: t('errors.form.REQUIRED'),
    types: {
      number: t('errors.form.NUMBER'),
      email: t('errors.form.EMAIL')
    },
    string: {
      len: 'Ce champs doit comporter ${len} caractères'
    }
  };
  const contextValue = {};

  return (
    <LanguageContext.Provider value={contextValue}>
      <ConfigProvider
        locale={frFR}
        renderEmpty={customizeRenderEmpty}
        form={{ validateMessages }}
      >
        {children}
      </ConfigProvider>
    </LanguageContext.Provider>
  );
};

export default () => useContext(LanguageContext);
